<template>
<div class="page-box">
    <ctrl-box class="ctrl-box" :data="{}" v-reheight="ctrlBoxHeightChanged">
        <el-link :underline="false" @click="showQuery = !showQuery">
            <div class="wrap" >
                <icon-svg icon-class="icon-search" font-size="27px;"/>
                <span class="txt" >{{msg('搜索')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="doImport()">
            <div class="wrap" >
                <icon-svg icon-class="icon-daoru3" font-size="27px;"/>
                <span class="txt" >{{msg('上传资料')}}</span>      
            </div>                
        </el-link>
        <!-- <el-dropdown @command="(cmd)=> doPrint(cmd)" >
            <el-link :underline="false">
                <div class="wrap" >
                    <icon-svg icon-class="icon-dayin2" font-size="27px;" style="color: rgb(76, 170, 172);  "/>
                    <span class="txt">{{ msg("打印") }}</span>      
                </div>
            </el-link>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1" >{{msg("打印货单") }}</el-dropdown-item>
                <el-dropdown-item :command="2" >{{msg("打印面单") }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown> -->
    </ctrl-box>

    <!--查询区域-->
    <transition name="el-zoom-in-top">
        <query-box :query="query" v-show="showQuery" labelWidth="80px">
            <template v-slot:default="scope">
                <el-form-item label="订单单号">
                    <el-input v-model="scope.query.code" size="mini" type="textarea" clearable/>
                </el-form-item>
                <el-form-item label="快递单号">
                    <el-input v-model="scope.query.innerExpCode" size="mini" clearable/>
                </el-form-item>
                <el-form-item label="采购单号">
                    <el-input v-model="scope.query.purchaseCode" size="mini" clearable/>
                </el-form-item>
                <el-form-item label="货态">
                    <el-select v-model="scope.query.status" size="mini" clearable>
                        <el-option v-for="d in getDicts('stockStatusInOrder')" :key="d.value" 
                            :label="d.label" :value="d.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="店铺名">
                    <el-input v-model="scope.query.shopName" size="mini" clearable/>  
                </el-form-item>
                <el-form-item label="采购时间">
                    <el-date-picker v-model="scope.query.PurchaseDate" size="mini" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="最后出货时间">
                    <el-date-picker v-model="scope.query.LastDate" size="mini" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="下单时间">
                    <el-date-picker v-model="scope.query.Date" size="mini" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-row>
                    <el-button type="primary" icon="el-icon-search" @click="getData(true)" size="mini">{{msg('搜索')}}</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                </el-row>
            </template>
        </query-box>
    </transition>

    <div class="table-wrap">
        <div class="data-row" v-for="(order, i) in orders" :key="i+1">
            <div style="width: 50%; display: flex; justify-content: space-around;margin-top:15px;margin-left:10px;font-size: 14px;">
                <span>{{ order.details[0].code }}</span>
                <span style="color:#dcdfe6">|</span>
                <span><el-tag  size="mini" :type="getStatusType(order.details[0])">{{ getStatus(order.details[0]) }}</el-tag></span>
                <span style="color:#dcdfe6">|</span>
                <span><el-link type="success" :underline="false">{{ order.details[0].shopName }}</el-link></span>
                <span style="color:#dcdfe6">|</span>
                <span><el-link type="primary" :underline="false">买家：{{ order.details[0].receiver }}</el-link></span>
                <span style="color:#dcdfe6">|</span>
                <span><el-link type="warning" :underline="false">买家留言：{{ order.details[0].shopSellerMsg }}</el-link></span>
            </div>
            <table :style="{ width: tableWidth + 'px' , minWidth: '800px'}">
                <tr v-for="(detail, index) in order.details" :key="index">
                    <!-- 新增复选框列 -->
                    <!-- <td :style="{ width: '20px' }">
                        <el-checkbox v-model="detail.selected"></el-checkbox>
                    </td> -->
                    <td style="width: 26%; min-width: 260px; max-width: 26%;">
                        <div class="item1" :style="{ width: (tableWidth * 0.26) + 'px' }">
                            <el-image  style="width: 100px; min-width: 100px; height: 100px" 
                                :src="kit.api.imgView+detail.productThumb" 
                                :preview-src-list="[kit.api.imgView+detail.productThumb]"
                            ></el-image>
                            <div class="product-info">
                                <div class="cell-1 product-row">
                                    <span class="product-title">{{ detail.productTitle }}</span>
                                    <span class="product-qty"><span>x</span>{{ detail.productQty }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>规格：</span>
                                    <span>{{ detail.productSpec }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>sku：</span>
                                    <span>{{ detail.sku }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>货号：</span>
                                    <span>{{ detail.variationSku }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>单价：</span>
                                    <span>{{ detail.productPrice > 0 ? (detail.productPrice / 100).toFixed(2) : '--'  }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>&nbsp; </span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td :style="{ width: (tableWidth * 0.03) + 'px', minWidth: '60px' }"
                        v-if="index == 0" :rowspan="order.details.length">
                        <el-tag :type="getStatusType(detail)">{{ getStatus(detail) }}</el-tag>  
                    </td>
                    <td :style="{ width: (tableWidth * 0.05) + 'px', minWidth: '140px' }"
                        v-if="index == 0" :rowspan="order.details.length"
                    >
                        <div class="ctrl-cell">
                            <div style="color: #ffa211;" @click="doPrint(1,detail)">
                                <i class="iconfont" >&#xe663;</i>
                                <span>打印货单</span>
                            </div>
                            <div style="color:#ff4a57;" @click="doPrint(2,detail)">
                                <i class="iconfont" >&#xe66d;</i>
                                <span>打印面单</span>
                            </div>
                        </div>
                    </td>
                    <td :style="{ width: (tableWidth * 0.1) + 'px', minWidth: '140px' }">
                        <div class="ctrl-cell">
                            <div style="color: #ff4a57;" @click="handlePurchase(detail)">
                                <i class="iconfont" >&#xe67b;</i>
                                <span>采购</span>
                            </div>
                            <div style="color:#ffa211;">
                                <i class="iconfont" >&#xe704;</i>
                                <span>匹配库存</span>
                            </div>
                            <div v-if="detail.hasLink" style="color: #2b92f6;">
                                <i class="iconfont" >&#xe6b0;</i>
                                <span>编辑货源</span>
                            </div>
                            <div v-else style="color: #2b92f6;">
                                <i class="iconfont" >&#xe6b0;</i>
                                <span>填写货源</span>
                            </div>
                            <div style="color: #ff4a57;" @click="addDetail(detail)">
                                <i class="iconfont" >&#xe6e9;</i>
                                <span>新增</span>
                            </div>
                        </div>
                    </td>
                    <td 
                        :style="{ width: (tableWidth * 0.1) + 'px', minWidth: '150px' }"
                    >
                        <div>
                            <div class="cell-2">采购单号：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span>{{ detail.purchaseCode }}</span>
                                </div>
                            </div>
                            <div class="cell-2">快递单号：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span>{{ detail.innerExpCode }}</span>
                                </div>
                                <el-link :underline="false" type="primary" @click="updateCode(detail)" title="更新快递单号">
                                    <i class="el-icon-edit-outline"></i>
                                </el-link>
                            </div>
                        </div>
                    </td>
                    <td 
                        :style="{ width: (tableWidth * 0.12) + 'px', minWidth: '160px' }"
                        v-if="index == 0" :rowspan="order.details.length">
                        <div>
                            <div class="cell-2">订单金额：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color: #e6a23c; font-weight: bold;">
                                        {{ detail.amtOrder > 0 ? (detail.amtOrder / 100).toFixed(2) : '--'  }}
                                    </span>
                                </div>
                            </div>
                            <div class="cell-2">采购金额：</div>
                            <div class="cell-3">
                                <div class="cell-4" >
                                    <span style="color: #f56c6c; font-weight: bold;">
                                        {{ order.details.filter(d => d.cost > 0).map(d => (d.cost / 100).toFixed(2)).join("+") }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td 
                        :style="{ width: (tableWidth * 0.16) + 'px', minWidth: '160px' }"
                        v-if="index == 0" :rowspan="order.details.length">
                        <div>
                            <div v-if="order.balanceTime" class="cell-2">发货剩余：</div>
                            <div v-if="order.balanceTime" class="cell-3">
                                <div style="color: #cd1b1b;">
                                    <i class="iconfont" >&#xe66b;</i>
                                    <span>{{ order.balanceTime }}</span>
                                </div>
                            </div>
                            <div class="cell-2">下单时间：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    {{ detail.created }}
                                </div>
                            </div>
                            <div class="cell-2">最后出货时间：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    {{ detail.shopDayToShip }}
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div><!--end data-row-->
    </div><!--end table-wrap-->

    <pagenator @page-change="handlerPageChange" :query="query" >
    </pagenator>
     <!--打印-->
     <stock-print :print-ctrls="printCtrls" ref="printDg" @print-finish = "getData"/>
     <buy-dialog ref="BuyDialogRef" @finish="getData"/>
     <add-stock-detail-dialog ref="AddStockDetailDialogRef" @finish="getData"/>
     <!--采购弹窗-->
    <stock-detail-purchase ref="purchasDg" :stocks="selectedStocks" @finish="getData"/>

    <el-dialog
        :title="msg('导入采购链接')" :fullscreen="isMinScreen"
        :visible.sync="importVisible"
        :close-on-click-modal="false"
        :before-close="doCloseImport"
        width="60%">
            <purchase-import @close-dg="importVisible=false"/>
    </el-dialog>

</div>
</template>

<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import StockPrint from "../store/StockPrint.vue";
import OrderService from "./OrderService.js"
import BuyDialog from "./BuyDialog.vue"
import StockDetailPurchase from "../store/StockDetailPurchase.vue";
import StockDetailService from '../store/StockDetailService.js';
import PurchaseImport from "../purchase/PurchaseImport.vue";
import AddStockDetailDialog from "../order/AddStockDetailDialog.vue"

export default {
    name: "Order1",
    components: {
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        StockPrint: StockPrint,
        BuyDialog: BuyDialog,
        StockDetailPurchase: StockDetailPurchase,
        PurchaseImport: PurchaseImport,
        AddStockDetailDialog: AddStockDetailDialog,
    },
    mounted: function(){
        this.user  = JSON.parse(localStorage.getItem("user"));
        this.getData();
        this.updateTableWidth();
        window.addEventListener('resize', this.updateTableWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateTableWidth);
    },
    directives: {
        reheight: {
            bind(el, binding) {
                let height = '';
                function isReheight() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (height !== style.height) {
                        binding.value(style.height);
                    }
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReheight, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        orderInfoWindowId: { //订单详情窗口id
            get() {
                var is = this.$store.state.orderInfoWindowId;
                return is;
            }
        }, 
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 260;
            }
        },

    },
    data(){
        return {
            emptyFixedBoxHeight: '37px',
            tableWidth: 800,
            query: {
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,

                code: '',
                innerExpCode: '',
                purchaseCode: '',
                status: '',
                shopName: '',
                PurchaseDate: '',   
                LastDate: '',
                Date: '',
                codeType: 3
            },
            showQuery: false,
            orders: [],
            printCtrls: [],
            selectedStocks: [],
            importVisible: false,
            user: null,
        }
    },
    methods: {
        reset() {
            this.$kit.clearQuery(this.query);
        },
        getData(refresh) {
            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
                // this.selectedRows = [];
            }
            this.query['codeType'] = 3;
            let param = this.$kit.rebuildQuery(this.query, ['Date', 'LastDate', 'PurchaseDate']);

            this.$axios.post(
                this.$kit.api.stockDetail.listByStock1, 
                param
            ).then((result) => {
                if(result.status){
                    let list = result.data.list;
                    this.orders = [];
                    let dataMap = {};
                    list.forEach(d => {

                        if(!dataMap[d.stockId]){
                            dataMap[d.stockId] = [];
                        }

                        dataMap[d.stockId].push(d);
                    });

                    Object.keys(dataMap).forEach(key => {

                        let balanceTime = null; 
                        let create = dataMap[key][0].created;
                        let shopDayToShip = dataMap[key][0].shopDayToShip;

                        if(create && shopDayToShip){
                            let diff = new Date(shopDayToShip) - new Date(create);
                            let days = Math.floor(diff / (1000 * 60 * 60 * 24));
                            let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                            let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                            balanceTime = `${days}天${hours}小时${minutes}分钟`;
                        }

                        this.orders.push({
                            stockId: key,
                            balanceTime: balanceTime,
                            details: dataMap[key]
                        });
                    });
                    this.query.pageTotal = result.data.total;
                }
            });

        },

        // 采购
        handlePurchase(detail){
            let selectes = [detail];
            //通过sku、货号去匹配采购链接，如果获取到则直接跳转
            this.selectedStocks = selectes.map(s => {return {stockId: s.stockId, detailId: s.id, qty: s.productQty}});
            let links = OrderService.concatPurchaseLink(selectes);
            if(links.length == 1){
                // window.OKK_Orders.openOrderInfo(this.$kit.api.stockDetail.orderInfo+"?id="+selectes[0].id, this.orderInfoWindowId || null, (windowId)=>{
                //     this.$store.commit('orderInfoWindowId', windowId);
                // });
                // window.open(links[0], "_blank");
                console.log('spec',detail.productSpec);
                let extId = document.body.getAttribute('ba-ext-id');
                /* global chrome */
                chrome.runtime.sendMessage(extId, {
                    action: 'buy',
                    data: [{
                        link: links[0],
                        name: detail.productTitle,
                        price: detail.productPrice,
                        specs: detail.productSpec.split(','),
                        platform: detail.purchasePlatform,
                        qty: detail.productQty
                    }]
                }, response => {
                    if (response.success) {
                        console.log('采购成功:', response.data);
                    } else {
                        console.error('采购失败:', response.error);
                    }
                });
                this.$refs.purchasDg.showDialog(); 
                return;
            }
            this.$refs.BuyDialogRef.checkNeedBuy(selectes,false, ()=>{
                this.$refs.purchasDg.showDialog();
            });
        },

        //新增一条详情
        addDetail(detail){
            let stock = {id:detail.stockId, status: detail.status};
            this.$refs.AddStockDetailDialogRef.showDialog({
                stockId: stock.id,
                status: stock.status
            });
        },

        //更新快递单号，更新架位号
        updateCode(detail){
            let stock = {id:detail.stockId, status: detail.status};
            let stockDetail = {id:detail.id, shelfCode: detail.shelfCode};
            StockDetailService.updateCode(
                stock,
                stockDetail,
                this.user.username,
                0,
                this.getData               
            );
        },
        doImport(){
            this.importVisible = true;
        },
        doCloseImport(done){
            this.getData();
            done();
        },
        ctrlBoxHeightChanged(height){
            this.emptyFixedBoxHeight = height;
        },
        doPrint(cmd,detail){
            this.$confirm(this.msg('是否要执行打印？'), this.msg('提示'), {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let selectes = [detail];
                if(cmd == 1){
                    this.printCtrls = [1]
                    this.$refs.printDg.preparePrint(selectes.map(s=>s.stockId), this.printCtrls);
                }else if(cmd == 2){
                    this.printCtrls = [0];
                    this.$refs.printDg.preparePrint(selectes.map(s=>s.stockId), this.printCtrls);
                }
            }).catch((err) => {
                // console.log(err);
            })
        },
        getStatus(stock){
            let status = this.getDicts('stockStatusInOrder').find(d => d.value === stock.status);
            return status? status.label: stock.status;
        },
        getStatusType(stock){
            let status = this.getDicts('stockStatusInOrder').find(d => d.value === stock.status);
            return status? status.type: 'primary';
        },
        
        callSelectedMethod(callMethod){
            // var selectes = this.$refs.dataTable.getCheckboxRecords();
            // if(selectes.length==0){
            //     this.$message(this.msg('请选中一条数据进行操作'));
            //     return;
            // }else{
            //     callMethod(selectes);
            // }
        },
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            // this.selectedRows = [];
            this.getData();
        },
        updateTableWidth() {
            const tableWrap = document.querySelector('.table-wrap');
            if (tableWrap) {
                this.tableWidth = tableWrap.offsetWidth;
            }
        },
    }

}


</script>

<style scoped> 
.table-wrap{
    width: 98%;
    height: 100%;
    overflow-y: auto;
    margin: 10px 7px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.data-row table{
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    margin: 10px 10px 10px 6px;
}

.data-row table{
    border-top: 1px solid #dcdfe6;
    /* border-left: 1px solid #dcdfe6; */
}

.data-row td{ 
    padding: 10px;
    border-right: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
}


.product-info{
    display: inline-block;
    width: calc(100% - 100px);
    overflow:hidden;
    box-sizing: border-box;
    padding-left: 10px;
}

.cell-1{
    font-size:12px;
    color: #666;
    display:flex;
}

.cell-1 > span:first-child{
    word-wrap: nowrap; 
    white-space: nowrap;
}
.cell-1 > span:last-child{
    color: #333; 
    word-wrap: nowrap; 
    white-space: nowrap;
}
  
.product-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 7px;
}

.product-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size:13px; 
    color: #000;
}

.product-qty {
    font-size:18px;
    color: #be0909 !important;
}

.product-qty span{
    font-size:13px;
    color: #888;
}

.ctrl-cell{
    margin-left: 10px;
    font-size: 14px; 
}

.ctrl-cell > div{
    display: flex;
    cursor: pointer;
    align-items: center;
    opacity: 1;
}

.ctrl-cell > div:hover{
    opacity: 0.8;
}

.ctrl-cell > div > i{
    margin-right: 8px;
}

.cell-2{
    font-size: 12px;
    color: #666;
    margin-top: 5px;
}

.cell-3{
    font-size: 14px;
    color: #333;
}


</style>
